import levenshtein from "js-levenshtein";

const getAllEditDistancesSync = (current, targetArray, upperBound) => {
  return targetArray
    .map((elem) => {
      return {
        word: elem,
        distance: levenshtein(current, elem),
      };
    })
    .filter((obj) => obj.distance <= upperBound);
};

export { getAllEditDistancesSync };
